import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'

interface IConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
}

const ConfirmModal = ({ open, onClose, onConfirm, title, message }: IConfirmModalProps) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={'sm'} aria-describedby="alert-dialog-slide-description">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{message}</DialogContent>
      <DialogActions>
          <Button
            startIcon={<ClearIcon />}
            color="inherit"
            onClick={onClose}
            size="large"
            variant="contained"
          >
            ยกเลิก
          </Button>
          <Button
            startIcon={<SaveIcon />}
            color="primary"
            onClick={onConfirm}
            size="large"
            variant="contained"

          >
            ยืนยัน
          </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmModal
